import { useCallback, useState } from 'react';

export type FacingMode = 'user' | 'environment';

export default function useFacingMode(defaultMode: FacingMode = 'user') {
  const [facingMode, setFacingMode] = useState<FacingMode>(defaultMode);

  const toggleFacingMode = useCallback(() => {
    setFacingMode(prev => prev === 'user' ? 'environment' : 'user');
  }, [setFacingMode]);

  return {
    facingMode,
    setFacingMode,
    toggleFacingMode
  };
}
